const HTTP_STATUS_MESSAGES = {
  400: 'The request was invalid. Please check your input and try again.',
  401: 'Your session has expired. Please log in again.',
  403: 'You do not have permission to perform this action.',
  404: 'The requested resource was not found.',
  410: 'This password reset link has expired. Please request a new one.',
  413: 'The file you uploaded is too large. Please reduce the file size and try again.',
  422: 'The data could not be processed. Please check your input and try again.',
  429: 'Too many requests. Please wait a moment and try again.',
  500: 'A server error occurred. Please try again later or contact support if the problem persists.',
  502: 'The server is temporarily unavailable. Please try again later.',
  503: 'The service is temporarily unavailable. Please try again later.',
  504: 'The request timed out. Please try again later.',
}

export const parseErrorResponse = error => {
  // Pass through local validation errors unchanged so field-level errors are preserved
  if (error.type === 'validation') {
    return error
  }
  if (!error.response) {
    return { message: error.message || 'An unexpected error occurred' }
  }
  const { status, data } = error.response

  // Handle simple { message: "..." } format (e.g. 403 Forbidden, 404 Not Found)
  if (data && data.message && !data.errors) {
    return {
      status,
      message: HTTP_STATUS_MESSAGES[status] || data.message,
    }
  }

  // Handle plain key-value errors { errors: { fieldName: "message string" } }
  // e.g. 422: { message: "Validation failed", errors: { oldPassword: "oldPassword is incorrect" } }
  const errorsObj = data && data.errors
  if (errorsObj && typeof errorsObj === 'object' && !Array.isArray(errorsObj)) {
    const firstValue = Object.values(errorsObj)[0]
    if (typeof firstValue === 'string') {
      return { status, ...errorsObj }
    }
  }

  // Handle JSON:API errors format
  const jsonApiResult = Object.values(errorsObj || {}).reduce((acc, item) => {
    const { source = {}, title, detail } = item
    const { parameter } = source
    const msg = detail ? `${title}: ${detail}` : title
    if (parameter) {
      acc[parameter] = msg
    }
    acc.errors = (acc.errors || []).concat(msg)
    return acc
  }, { status })

  // If no field errors were extracted, include a generic status message
  if (Object.keys(jsonApiResult).filter(k => k !== 'status' && k !== 'errors').length === 0) {
    jsonApiResult.message =
      HTTP_STATUS_MESSAGES[status] ||
      (data && data.message) ||
      (jsonApiResult.errors && jsonApiResult.errors[0]) ||
      'An unexpected error occurred'
  }

  return jsonApiResult
}
